import * as React from 'react';

import { ProgressContent, TicketDetailForVGSelections, TicketSummary } from 'common--design-library';
import { IMobileTicketDetailForVGProps } from '../../mobile/mobileTicketDetailForVG/mobileTicketDetailForVG';
import { Actions } from '../ticketDetail/actions';
import { TicketTypeForVG } from 'eTip--common';
import { ITranslationForMts, translationForMts } from 'easit--localization';

export interface IDesktopTicketDetailForVGProps extends IMobileTicketDetailForVGProps {
    title: string;
    goBack: () => void;
    refresh: () => void;
}

export const getTicketTypeText = (ticketType: TicketTypeForVG, translation: ITranslationForMts): string => {
    switch (ticketType) {
        case TicketTypeForVG.Single: return translation.ticket_TicketTypeSimple;
        case TicketTypeForVG.System: return translation.ticket_TicketTypeSystem;
        case TicketTypeForVG.Split: return translation.ticket_TicketTypeVGSplit;
        case TicketTypeForVG.Combi: return translation.ticket_TicketTypeVGCombi;
    }
    throw new Error("Unexpected type " + ticketType);
}

export const TicketDetailForVG: React.FC<IDesktopTicketDetailForVGProps> = (props) => {

    const t = translationForMts();

    return <><div className="ticket-detail bet-detail-component">{/* TODO bet-detail-component is for cashout, see betDetailCashout.scss */}
        <div className={"d-flex justify-content-between w-100"}>
            <h1 className="p-1" data-test-role="ticket-detail--header">{props.title}</h1>
            {<Actions back={props.goBack} refresh={props.refresh} />}
        </div>
        {

            <div className="w-100 detail-panels-wrapper">
                <div className="detail-panel summary-panel float-left">
                    <div className="w-100">
                        <ProgressContent state={props.state} errorMessage={props.error} inline={true} className="p-2">
                            {<TicketSummary
                                {...props}
                                showHeader={true}
                                offerTypeAsText={"Virtuálne hry"}
                                ticketTypeAsText={getTicketTypeText(props.ticketType, t)}
                                dateCancelationLimit={null}
                                canShowCancelButton={false}
                            />}
                        </ProgressContent>
                    </div>
                </div>
                <div className="detail-panel selections-panel float-right">
                    <TicketDetailForVGSelections
                        selections={props.selections}
                    />
                </div>
            </div>
        }
    </div>
    </>
}